import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Marks the calls `refreshSession` makes, so `authInterceptor` does not answer their 401 by
 * refreshing again.
 *
 * Without it a 401 on the profile read re-enters the shared in-flight refresh and the chain waits on
 * itself: nothing is in flight, `finalize` never runs, and every later session restore hangs on the
 * same dead observable. A URL check would not cover it — the mark travels with the request, so a
 * call added to the refresh chain later is safe by construction.
 */
export const IS_SESSION_REFRESH = new HttpContextToken(() => false);

/** Context for the calls above — pass as `{ context: isSessionRefresh() }`. */
export function isSessionRefresh(): HttpContext {
  return new HttpContext().set(IS_SESSION_REFRESH, true);
}
